import React from "react";
import { Tabs } from "antd";
import PatientRecordTable from "./PatientRecordTable";
import { EyeFilled, DownloadOutlined } from "@ant-design/icons";

const { TabPane } = Tabs;

const PatientRecordTabs = () => {
  const columns = [
    {
      title: "Date of Upload",
      dataIndex: "dateofupload",
      key: "dateofupload",
      align: "center",
    },

    {
      title: "Author",
      dataIndex: "author",
      key: "author",
      align: "center",
    },
    { title: "Contact", dataIndex: "contact", key: "contact", align: "center" },
    { title: "Tags", dataIndex: "tags", key: "tags", align: "center" },

    {
      title: "",
      key: "operation",
      render: () => (
        <div>
          <a style={{ color: "#9254DE", fontWeight: "500" }} href="/">
            <EyeFilled
              style={{ fontSize: 22, fontWeight: "bold", paddingRight: 15 }}
            />
          </a>
          <a style={{ color: "#9254DE", fontWeight: "500" }} href="/">
            <DownloadOutlined style={{ fontSize: 22, fontWeight: "bold" }} />
          </a>
        </div>
      ),
      align: "center",
    },
  ];

  const data = [];
  for (let i = 0; i < 30; ++i) {
    data.push({
      key: i,
      dateofupload: "09/09/2020",
      author: "Chirag Dugar",
      contact: 9874562140,
      tags: "High BP, Low Sugar",
    });
  }

  return (
    <div className="row" style={{ marginTop: "2rem" }}>
      <Tabs defaultActiveKey="1" tabBarStyle={{ color: "rgba(0, 0, 0, 0.65)" }}>
        <TabPane tab="All" key="1">
          <PatientRecordTable columns={columns} data={data} />
        </TabPane>
        <TabPane tab="Prescriptions" key="2">
          <PatientRecordTable columns={columns} data={data} />
        </TabPane>
        <TabPane tab="Reports" key="3">
          <PatientRecordTable columns={columns} data={data} />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default PatientRecordTabs;
